module.exports = __webpack_public_path__ + "media/images/categories/color/bk-321fd36c18a0131cbd46758c49e43b9c.png";